const template = require('./simple-plan.html.slim')
import * as _ from 'lodash'

declare var angular

export class SimplePlan {
  static $inject = ['plans']

  public planData
  public retirement
  public gradient: {}[]
  public gradient2: {}[]
  public ageTicks: number[]
  public retirementResult = {
    savings: 0,
    mutualFund: 0,
  }
  public plan = {
    age: 0,
    retirementAge: 30,
    monthlyContribution: 0,
    savings: 100000,
    retirementIncome: 50000,
  }

  public timeTicks = [0, 30]
  public valueTicks = []
  public mutualFundMax = 0
  public savingsMax = 0

  private planResource
  private _savings = this.plan.savings

  constructor(private plans) {
    this.planResource = plans
    this.updateData(this.plan)
  }

  get savings() { return this.plan.savings }
  set savings(value) {
    this.plan.savings = +value
    this.updateData(this.plan)
  }

  public updateData(values): void {
    if (values) {
      var plan = this.planResource.newPlan(values)
      var planData = this.planResource.calculatePlanData(plan)
      planData.forEach((v) => { v.year = v.month / 12 })
      this.planData = planData.slice(0, 12 * 30 + 1)
      var last = this.planData[this.planData.length - 1]
      this.mutualFundMax = last.mutualFund
      this.savingsMax = last.savings
      this.valueTicks = [this.mutualFundMax, this.savingsMax]
    }
  }

  public savingsFilter(data) {
    var last = data[data.length - 1]
    return [0, last.mutualFund, last.savings, last.savings * 1.2]
  }
}

angular.module('wbComponents').directive('simplePlan', function() {
  return {
    restrict: 'AE',
    templateUrl: template,
    controller: SimplePlan,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      plan: '=',
      retirementResult: '=',
    },
  }
})
